(function () {
    'use strict';

    angular
        .module('sodCommon')
        .filter('limitToEllipsis', limitToEllipsis);

    function limitToEllipsis($filter) {
        return function(text, length, isBool) {
            if (typeof text !== typeof '') return text;

            if (isBool) return text.length > length;

            return $filter('limitTo')(text, length).trim()  + ((text.length > length) ? '...' : '');
        };
    }
})();